import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=15c008c2&"
import script from "./ImageModal.vue?vue&type=script&lang=ts&"
export * from "./ImageModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports